import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export function RoundCheckboxIcon(props: SvgIconProps) {
  return (
    <SvgIcon
      {...props}
      viewBox='0 0 16 16'
      fill='none'
    >
      <rect
        width='16'
        height='16'
        rx='4'
        fill={props.fill ?? '#3E8FFA'}
      />
      <g clipPath='url(#clip0_1067_43511)'>
        <path
          d='M6.93004 11.0004C6.86148 11.0002 6.7937 10.9859 6.73091 10.9584C6.66812 10.9309 6.61166 10.8907 6.56504 10.8404L4.13504 8.25544C4.04421 8.15864 3.99555 8.02972 3.99976 7.89703C4.00398 7.76435 4.06074 7.63878 4.15754 7.54794C4.25435 7.45711 4.38327 7.40845 4.51595 7.41267C4.64863 7.41688 4.77421 7.47364 4.86504 7.57044L6.92504 9.76544L11.13 5.16544C11.1727 5.1123 11.2258 5.06845 11.286 5.03658C11.3463 5.0047 11.4124 4.98548 11.4803 4.98008C11.5483 4.97469 11.6166 4.98324 11.6811 5.00522C11.7456 5.02719 11.805 5.06212 11.8555 5.10787C11.906 5.15361 11.9466 5.2092 11.9749 5.27121C12.0032 5.33323 12.0184 5.40037 12.0198 5.46851C12.0212 5.53665 12.0086 5.60435 11.9828 5.66745C11.9571 5.73055 11.9187 5.78772 11.87 5.83544L7.30004 10.8354C7.25386 10.8866 7.1976 10.9277 7.13479 10.9561C7.07198 10.9845 7.00397 10.9996 6.93504 11.0004H6.93004Z'
          fill='white'
        />
      </g>
      <defs>
        <g clipPath='url(#clip0_1067_43511)'>
          <rect
            width='12'
            height='12'
            fill='white'
            transform='translate(2 2)'
          />
        </g>
      </defs>
    </SvgIcon>
  );
}
